import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {AfterMatchEvent} from "@/modules/match/events/AfterMatchEvent";
import {BankCategory} from "@/modules/finances/enums";
import {Sponsor} from "@/modules/sponsoring/entity";
import {LeagueCompetition} from "@/modules/competitions/entity";
import {MatchResultEnum} from "@/modules/base/enums";
import {GateTypeEnum} from "@/modules/action-points/enums";
import GateManager from "@/modules/action-points/services/GateManager";

@injectable()
export class SponsoringEventSubscriber implements EventSubscriber {
  constructor(
    @inject(GateManager) private gateManager: GateManager,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterMatchEvent, callback: this.onAfterMatchEvent},
    ];
  }

  async onAfterMatchEvent(event: AfterMatchEvent): Promise<void> {
    if (!event.match.homeTeam.user && !event.match.awayTeam.user) {
      return;
    }

    const sponsor = await Sponsor.findOne({
      where: {
        accepted: true,
      }
    });

    if (!sponsor) {
      return;
    }

    const isLeague = event.competition instanceof LeagueCompetition;

    await this.gateManager.getGate(GateTypeEnum.BALANCE).currency.add(
      isLeague ? sponsor.perLeagueMatch : sponsor.perCupMatch,
      {
        category: BankCategory.SPONSORING,
        label: translator.t(isLeague ? 'league_match' : 'cup_match'),
      }
    );

    if (
      event.match.homeTeam.user && event.match.result === MatchResultEnum.HOME_WIN
      || event.match.awayTeam.user && event.match.result === MatchResultEnum.AWAY_WIN
    ) {
      await this.gateManager.getGate(GateTypeEnum.BALANCE).currency.add(
        isLeague ? sponsor.perLeagueVictory : sponsor.perCupVictory,
        {
          category: BankCategory.SPONSORING,
          label: translator.t(isLeague ? 'league_match_victory' : 'cup_match_victory'),
        }
      );
    }
  }
}